<template>
  <div>
    <div
      v-show="h_visible_pop"
      class="pop-wrap"
      @touchmove.prevent
    >
      <div 
        class="pop-mask" 
        @click="clickClosemask"
      />
      <div
        ref="refpop"
        class="pop-body"
      >
        <!-- 用户信息 -->
        <InfoUser 
          v-model="userinfo"
          @res="clickClosemask"
        />

        <!-- 档位 -->
        <div class="bg_white">
          <!-- 支付档位 -->
          <div class="pop-body-bd">
            <div class="center">
              <swiper
                ref="mySwiper"
                :options="swiperOption"
              >
                <swiper-slide
                  v-for="(item, index) in goodslist"
                  :key="index"
                >
                  <div
                    :class="{'on':(item.id > 0 && item.id == h_data_goodinfo.id)}"
                    class="slideitem flex_layout flex_flexDirection_column flex_y_start"
                    @click="clickGoods(item,true)"
                  >
                    <div v-show="h_visible_ui">
                      <div
                        :class="{'opacity0':!getImageIcon(item,'icon')}"
                        class="i-0"
                      >
                        <img :src="getImageIcon(item,'icon')">
                      </div>
                      <div class="i-1">
                        <p class="pf-regular">
                          {{ item.title }}
                        </p>
                      </div>
                      <div class="i-2 flex_layout flex_y_end">
                        <div
                          class="i-2-1 flex_layout flex_y_end"
                          v-html="formatHtmlPrice(item)"
                        />
                        <div
                          class="i-2-2 flex_layout flex_y_end"
                          v-html="formatHtmlPricesub(item)"
                        />
                      </div>
                      <div
                        class="i-3"
                        v-html="formatHtmlTip(item)"
                      />
                      <div
                        :class="{'opacity0':!getImage(item,'banner')}"
                        class="i-4"
                      >
                        <img :src="getImage(item,'banner')">
                      </div>
                    </div>
                  </div>
                </swiper-slide>
              </swiper>
            </div>
            <!-- 提示信息 -->
            <div class="bottom">
              <div class="line flex_layout flex_y_center">
                <SetScale
                  v-if="sale_tips"
                  :world="sale_tips"
                  scale="0.8"
                >
                  <div class="pf-regular first-span">
                    {{ sale_tips }}
                  </div>
                </SetScale>
                <span class="pf-regular last-span">{{ sale_text }}</span>
              </div>
            </div>
            <!-- 优惠券显示 -->
            <div
              v-show="false"
              class="coupon-wrap"
            >
              <div class="line flex_layout flex_x_spacebetween flex_y_center">
                <div class="coupon-wrap-l flex_layout flex_xy_center">
                  <div class="coupon-wrap-l-ico" />
                  <span class="pf-regular">使用优惠券</span>
                </div>
                <div
                  v-if="!h_visible_hascoupon"
                  class="coupon-wrap-r flex_layout flex_xy_center pf-regular"
                >
                  <i>无可用优惠券</i><i class="opacity0" />
                </div>
                <div
                  v-if="h_visible_hascoupon"
                  class="coupon-wrap-r flex_layout flex_xy_center pf-regular"
                >
                  <i v-html="h_data_goodinfo.coupontitle" /><i />
                </div>
              </div>
            </div>
            <!-- 支付按钮 -->
            <div
              :class="{'red':h_btn_color}"
              class="btn pf-medium"
              @click="clickPay"
              v-html="formatHtmlBtnstr()"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
 
<script>
//npm模块
import "swiper/dist/css/swiper.css";//这里注意具体看使用的版本是否需要引入样式，以及具体位置。
import { swiper, swiperSlide } from "vue-awesome-swiper";

//组件
import InfoUser from "@/components/native/pay/comp/InfoUser";
import Loading from "@/components/native/pay/comp/Loading";
import SetScale from "@/components/native/pay/comp/SetScale.vue";
//公用方法
import slide from "@/assets/js/common/animation/slide";
import {formatFenToYuan} from "@/assets/js/common/fn/number";
import {getDeepVal} from "@/assets/fe_js/common/base/fn/object";

export default {
    name: "BuyVipPop",
    components: {
        swiper,
        swiperSlide,
        InfoUser,
        // Loading,
        SetScale
    },
    props: {
        dialogname: {
            type: String,
            default: ""
        },
        api_goodsdata:{
            type: Object,
            default: () => {
                return {};
            }
        },
        req_data:{
            type: Object,
            default: () => {
                return {};
            }
        },
    },
    data () {
        return {
            h_visible_pop   : false,
            h_visible_loading : true,
            h_visible_ui : false,
            h_visible_hascoupon:false,
            h_btn_color     : false,
            h_data_goodinfo : {},
            swiperOption: {
                // autoplay: true,//可选选项，自动滑动
                // slidesPerView: 'auto', //5.1,
                slidesPerView: 3.18, //5.1,
                // loopedSlides: 4,
            },
        };
    },
    computed: {
        swiper() {
            return this.$refs.mySwiper.swiper;
        },
        userinfo() {
            var user = this.api_goodsdata.user;
            var vip_user = this.api_goodsdata.vip;
            return {
                user,
                vip_user
            };
        },
        goodslist() {
            let recharge_goods = getDeepVal(this.api_goodsdata,"members.0.recharge_goods",[]);
            let renew_goods = getDeepVal(this.api_goodsdata,"members.0.renew_goods",[]);
            // console.log();
            let goods = this.api_goodsdata.user_member_renew_status ? recharge_goods : renew_goods.concat(recharge_goods);

            goods.forEach((item,index) => {
                item.price = {
                    mark_price:item.mark_price,
                    real_price:item.real_price,
                    promotion_price:item.promotion_price,
                };
                item.words_info = {
                    discount_tips:item.discount_tips,
                    visitor_text:item.visitor_text,
                    sale_tips:item.sale_tips,
                    coupon_tips:item.coupon_tips,
                    sale_text:item.sale_text,
                    promotion_btn_text:item.promotion_btn_text,
                    promotion_text:item.promotion_text,
                };
                item.image_info = {
                    icon:item.icon,
                    banner:item.banner
                };
            });
            return goods;
        },
        sale_tips(){
            return this.getWord(this.h_data_goodinfo,"sale_tips");
        },
        sale_text(){
            return this.getWord(this.h_data_goodinfo,"sale_text");
        }
    },
    watch: {
        dialogname:{
            handler(val, oldval){
                if (val == "dialog-poppayment-child" || oldval == "dialog-poppayment-child") {
                    return null;   
                }
                if (val == "dialog-pullupvip") {
                    this.openmask();
                } else {
                    this.closemask();
                }
            },
            deep:true
        },
    },
    methods:{
        openmask(){
            this.h_visible_pop = true;
            this.$nextTick(() => {
                slide.up(this.$refs.refpop, () => {
                    if (!this.h_visible_ui) {
                        this.h_visible_ui = true; 
                        this.h_visible_loading = false;  
                    }
                });
            });

            //1.判断所有商品里是否有优惠券
            this.settingVisibleHascoupon();
            this.choiseGood();
        },
        closemask(){
            slide.down(this.$refs.refpop);
            setTimeout(() => {
                this.h_visible_pop = false;//关闭时为了有slide效果
            },300);
        },
        //点击－商品
        clickGoods(obj){
            this.goodslist.forEach((item, index) => {
                if (obj.id == item.id) {
                    this.$set(this, "h_data_goodinfo", item);
                    this.setCouponInfo();//设置coupon
                    this.$emit("selectgood",this.h_data_goodinfo);
                }
            });
        },
        clickPay(){
            this.$emit("open","dialog-poppayment-child");
        },
        clickClosemask(){
            this.$emit("close");
        },
        //选中第一个商品
        choiseGood(){
            //端外优惠券列表里选中后回到当前页面时需要指定选中的档位 || 传递参数选中档位
            var good_id = this.req_data.good_id;
            var good_info = "";
            var num = 0;
            this.goodslist.forEach((item, index) => {
                if (item.id == good_id) {
                    good_info = item;
                    num = index;
                }
            });
            if (good_info) {
                this.clickGoods(good_info);
            } else {
                this.clickGoods(this.goodslist[0]);
            }
            return num;
        },
        //设置coupon信息
        setCouponInfo(){
            let opt = this.formatCoupon(this.h_data_goodinfo);
            this.$set(this.h_data_goodinfo, "coupontitle", opt.coupontitle);
            this.$set(this.h_data_goodinfo, "couponprice", opt.couponprice);
            this.$set(this.h_data_goodinfo, "couponid", opt.couponid);
            //活动而加的
            this.$set(this.h_data_goodinfo, "coupon_price", opt.couponprice);
            this.$set(this.h_data_goodinfo, "deal_price", this.getPrice(this.h_data_goodinfo,"real_price") - opt.couponprice);
        },
        //判断所有商品里是否有优惠券-
        settingVisibleHascoupon(){
            this.goodslist.forEach((item,index) => {
                if (getDeepVal(item,"coupon.usable_list",[]).length > 0) {
                    this.h_visible_hascoupon = true;
                }
            });
        },
        getSelectCouponPrice (good) {
            var opt = this.formatCoupon(good);
            return opt.couponprice;
        },
        formatCoupon (good) {
            var ary         = getDeepVal(good,"coupon.usable_list",[]);
            var sel_couponid= "";

            var coupontitle = "暂无优惠券，换个套餐试试";
            var couponprice = 0;
            var couponid    = 0;
            
            //1.默认第一个 || 最大的一个
            if (ary.length > 0) {
                var cop  = ary[0];
                //外层控制是否用最大的一个
                if (this.req_data.coupon_type == 1) {
                    var coplist = JSON.parse(JSON.stringify(ary));
                    coplist.sort(function(a, b){return b.amount - a.amount});
                    cop  = coplist[0];
                }
                cop.coupon_time_tip = cop.coupon_time_tip || "";
                coupontitle = '<div class="price"><span>'+cop.coupon_time_tip+"</span><span>-￥"+formatFenToYuan(cop.amount,2)+"</span></div>";
                couponprice = cop.amount;
                couponid    = cop.id;
            }
            //2.选中的
            if(ary.length > 0 && sel_couponid) {
                ary.forEach((item,index) => {
                    if (item.id == sel_couponid){
                        item.coupon_time_tip = item.coupon_time_tip || "";
                        coupontitle = '<div class="price"><span>'+item.coupon_time_tip+"</span><span>-￥"+formatFenToYuan(item.amount,2)+"</span></div>";
                        couponprice = item.amount;
                        couponid    = item.id;
                    }
                });
            }
            //3.不使用优惠券
            if (sel_couponid == "noneuse") {
                coupontitle = "暂不使用优惠券";
                couponprice = 0;
                couponid    = 0;
            }
            return {
                coupontitle : coupontitle,
                couponprice : couponprice,
                couponid    : couponid,
            };
        },
        formatHtmlPrice(item){
            let couponprice  = this.getSelectCouponPrice(item);
            couponprice = this.h_visible_hascoupon ? couponprice : 0;
            if (this.getPrice(item,"real_price")) {
                return '<span class="pf-regular">￥</span><span class="pf-semibold">'+formatFenToYuan(this.getPrice(item,"real_price") - couponprice)+"</span>";    
            }
        },
        formatHtmlPricesub(item) {
            let couponprice  = this.getSelectCouponPrice(item);
            if (couponprice > 0 && this.h_visible_hascoupon) {//iap支付不能显示优惠券
                return '<span class="price-sub-icon pf-regular">¥</span>'+
                       '<span class="price-sub decoration pf-regular">'+formatFenToYuan(this.getPrice(item,"real_price"))+"</span>";
            } else if (this.getPrice(item,"mark_price") > this.getPrice(item,"real_price"))  {
                return '<span class="price-sub-icon pf-regular">¥</span>'+
                       '<span class="price-sub decoration pf-regular">'+formatFenToYuan(this.getPrice(item,"mark_price"))+"</span>";
            }
        },
        //
        formatHtmlTip(item) {
            let couponprice  = this.getSelectCouponPrice(item);
            if (couponprice > 0 && this.h_visible_hascoupon) { //iap支付不能显示优惠券
                return '<div class="tip a flex_layout flex_xy_center"><span class="pf-regular">已抵扣¥'+formatFenToYuan(couponprice)+"</span></div>";
            }
            if (this.getWord(item,"discount_tips")) {
                return '<div class="tip b flex_layout flex_xy_center"><span class="pf-regular">'+this.getWord(item,"discount_tips")+"</span></div>";
            }
            if (item.description) {
                return '<div class="tip c flex_layout flex_xy_center"><span class="pf-regular">'+item.description+"</span></div>";
            }
        },
        formatHtmlBtnstr() {
            let btn = this.getWord(this.h_data_goodinfo,"promotion_btn_text");
            if (btn) {
                this.h_btn_color = true;
                return '<span class="fy">'+btn+"</span>";//免费体验7天
            }
            this.h_btn_color = false;
            let v0 = this.getPrice(this.h_data_goodinfo,"mark_price") || 0;
            let v1 = this.getPrice(this.h_data_goodinfo,"real_price") || 0;
            let v2 = this.h_data_goodinfo.couponprice || 0;
            let v3 = formatFenToYuan(v1 - v2);
            if (v2>0 && this.h_visible_hascoupon){//iap支付不能显示优惠券
                return '<div class="pp">立即支付<span>￥'+v3+"</span><span>￥"+formatFenToYuan(v1)+"</span></div>";
            } else {
                if (this.userinfo.vip_user && !this.userinfo.vip_user.has_charge_record) {
                    return "<span>立即开通</span>";
                } else {
                    return "<span>立即续费</span>";
                }
            }
        },
        getPrice(obj, key){
            let v = obj.member_good_price ? obj.member_good_price : obj.price ? obj.price : {};
            return v[key] ? v[key] : 0;
        },
        getImageIcon(obj, key){
            if (getDeepVal(obj,"comboinfo.combo_right_icon","")) {
                return obj.comboinfo.combo_right_icon;
            } else {
                return this.getImage(obj, key);
            }
        },
        getImage(obj, key){
            let v = obj.image_info ? obj.image_info : {};
            return v[key] ? v[key] : "";
        },
        getWord(obj, key){
            let v = obj.words_info ? obj.words_info : {};
            return v[key] ? v[key] : "";
        },
    }
};

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
@require "~@/assets/css/public/trans.styl"
@require "~@/assets/css/public/reset.styl"
.pop-wrap.show{display:block;}
/deep/ .pop-wrap{
   z-index:998;position: fixed;left:0;top:0;height:100%;width:100%;overflow: hidden;
    .pop-mask{
        position: absolute;left:0;top:0;height:100%;width:100%;overflow: hidden;background: rgba(0,0,0,.5);
    }
    .pop-mask.transparentbg{background: rgba(0,0,0,0);}
    .pop-body{
        transform: translate3d(0,100%,0);/*background: #fff;*/
        position: absolute;left:0;bottom:0;width:100%;font-size: trans(24);color:#000;
        .bg_white{
            background: #fff;
            .pop-body-bd{
                padding-top: trans(16);
                padding-bottom: trans(80);
                .center{
                    margin-left:trans(16);
                    .swiper-slide {
                        padding-right:trans(16);
                        .slideitem{position: relative;padding-left:trans(16);position:relative;width:trans(222);height:trans(282);overflow: hidden;background: #F9F6FF;border-radius: trans(8);}
                        .slideitem.on{background: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAN4AAAEaCAMAAABJtxmTAAAAolBMVEUAAAClRP93Kv+tVP+qSv9+Mf+BOv+yW/+JRv+0YP+MS/+0Yf+yXf+IRv+LS/+1Yv+MTf+NS/////+iO/9vIP9+J/+cN/96Jf+UM/9yIf93JP+fOf+ZNv91I/+XNf+ML/+QMf+BKf+DKv+SMv+FK/+JLv+OMP+ILf+GLP/69f/u4P/jzP+6bf/28f/HqP+FQP+ILv/asf+XXP+WW/+TVv/asv9WEcboAAAAEnRSTlMA/f36HBz02tq/v4RdXYSHh4Tw1WieAAADmklEQVR42uzUwaqDMBSE4YiCiIVChCBEEiFEqO2mi/v+r3aP4sJXmOn8K7cfc4y76sa+bSaKmrYfO3evGyayhhvwQbLbvebhrp6T9fnbX56i1/79TNbz2s4+27en6t0a6tyva2w6kuFuE9qATWe8wbaj05nP9htsvClOZJd53afBOjfaaXrKPnEaXR/j11P2jbF3dqK7p2yPsXVNjIQPy9ErxsbFGD1pRhMPNvGQEw858ZATD7mDF8QDLcTgQgieNONRrxe41xMPOPGQEw858ZATD7kf4C3cPOL1lrAwr0fOC0twy7J40sh5RhMPNvGQEw858ZBj5yVqXlqSSyl50k4e+XrigXY+Lbz/nvGon5bE/XKKB5x4yImH3Jxml+bZk3bwZt710pyo15ttPfFAEw858ZATDznxkBMPuV/gleJJO3iFeL1CvV6ZiyvEvCIebuIhJx5y4iG3ris1rxhvXT1px3orMa9w88jXEw848ZATD7mTt22eNHLetm5uI+Zt4uEmHnLiIXfycvaksa+XqXl5yy7zHmfO3DytB5x4yImHnHjInbxaPWk1V1e516vE69UqHmziISfeP7t0kOJADMRQtMgiZDtFjCmDFzYe7GQRmrn/4SbuW0itf4OHhNwVeHM6aeS8+Ttt8p7zmAcz71yP+Jxz2kHMO+jXEw+1k7eWk7Z5i3i9RX3ONZct3nN+ecznZF9vca+3+Nfj5Y01bPDy1ljMvHO9MZy0McTDTTzkxEPuArwuHmh9dOu9O2lfGvV6nX898UATDznxkGu9WePl9d6Zeed6rTlprXGfs3X69cQDTTzkxENu8xIxL3Hz9nopOWlfmjViXkvs64mHmnjIiYeceMiJh5x4yImHnHjI5ZSZeVdYL2cnbfMy73opJ8vE6+UsHmziIScecuIhJx5y4iFHziu5WC7FSdvrFd71csnM6+1zFmJeEQ838ZATDznxkBMPuVqqVV7eBdYrtTpp7Oes9OesxOes3DytB5x4yImHHDsvuHl7vQgnLSIsuNcL8vXEA0085MRDTjzkxENu824RL6fsFXGze8TbKXtH3O0R8XHKPhEP+3k+/5yy/+7q6ARCGAjC8BBYkUCCyP+yJZwhBk77r+0OUbCG/ToYZmC+eJW509aAmrublPHR13D6gCzJEpzh8vUTkumvACPYPtsAii6LA8e+Bfm/z7YfgC+6lUQ4qUgPy04onk1vVucpSIdpmusT7gcV6XsivxmHbgAAAABJRU5ErkJggg==") no-repeat 0 0;background-size: 100% 100%;}
                    }
                    .i-0{
                        position: absolute;left:0;top: 0px;width: 100%;height: trans(40);overflow: hidden;
                    }
                    .i-1{
                        position: absolute;left: trans(16);top: trans(32);font-size: trans(26);color:#333;
                        p{
                            white-space: nowrap;overflow: hidden;-webkit-text-overflow: ellipsis;-moz-text-overflow: ellipsis;text-overflow: ellipsis;width: trans(200);
                        }
                    }
                    .i-2 {
                        position:absolute;left:trans(16);top:trans(60);
                        .i-2-1.android {
                            span:first-child{margin-bottom: 0;line-height:trans(20);}    
                            span:last-child{line-height: trans(32);}
                        }
                        .i-2-1{
                            color:#000;height: trans(58);
                            span:first-child{margin-bottom: -trans(3);font-size: trans(26);line-height:trans(20);}
                            span:last-child{font-size:trans(52);line-height: trans(36);}
                        }
                        .i-2-2.android{margin: 0 0 trans(4) trans(8);}
                        .i-2-2{
                            margin: 0 0 trans(3) trans(8);font-size:trans(40);line-height:trans(16);color: rgba(0,0,0,.4);text-decoration: line-through;transform: scale(.5);-webkit-transform: scale(.5);transform-origin: left bottom;-webkit-transform-origin: left bottom;
                            span:first-child{}
                            span:last-child{}
                        }
                    }
                    .i-3{
                        position:absolute;left:trans(16);top:trans(132);
                        .tip.a {border: 1px solid rgba(255,79,0,0.10); background: #FFFFFF;color: #FF4F00;}
                        .tip.b {border: 1px solid #F0EDF6;background: #FFFFFF;color: #B2B4C4;}
                        .tip.c {border: 1px solid #F0EDF6;background: #FFFFFF;color: #999;}
                        .tip{
                            background:#fff;height: trans(46);border-radius: trans(28);transform: scale(.75);transform-origin: left bottom;
                            span{font-size: trans(24);white-space: nowrap;padding: 0 trans(16);}
                        }
                    }
                    .i-4{position: absolute;top: trans(188);left: 0;width: 100%;overflow: hidden;}
                }
                .bottom.show{display: block;}
                .bottom{
                    padding:0 trans(16);margin-top: trans(24);font-size:trans(24);
                    .scalebox_container{display:inline-block;}
                    .first-span{

                        border-radius:trans(20);padding:trans(3) trans(12);display:inline-block;color: #FF4F00;background: #fef1ea;
                    }
                    .last-span{
                        overflow: hidden;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                        color: #666;padding: trans(3) 0 trans(3) trans(15);
                    }
                    .line{
                        height:trans(40);
                        white-space: nowrap;
                    }
                }
                .coupon-wrap.show{display: block;}
                .coupon-wrap{
                    padding:0 trans(16);margin-top: trans(24);
                    i {
                        font-style: normal;
                    }
                    .line{
                        border-top: 1px solid #eee;border-bottom: 1px solid #eee;padding: trans(22) 0;
                    }
                    .coupon-wrap-l{
                        font-size: trans(24);color: #333;
                    }
                    .coupon-wrap-l-ico{
                        width: trans(30);height: trans(30);margin-right: trans(8);background: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC0AAAAtCAMAAAANxBKoAAAAe1BMVEUAAAD/UAD/UAD/UQD/VQD/TwD/TwD/UAD/TwD/TwD/TwD/TwD/UAD/UAD/UgD/UAD/VQD/VQD/TwD/////vZ//lmj/kGD/ayn/spD/+Pb/7eX/4NP/1cP/lGX/ZSD/Yx7/XRX/VAj/w6j/49j/3tD/nnP/iFP/gEj/cTIhWpOAAAAAEnRSTlMAgNJbHvjx5sGnjmdcUEE2JwONT7G+AAAA3ElEQVRIx+3T2QqDMBAFUGPtXte477v+/xd2MhQ0FR3okxQv6L3E8yREObKak+qsRz19YWc7MlcJrUraobJ/XVXTIHUfRT4OP4p6Urec8ww6g25JXXPkmaia1GWCTrySktIfPmFCF2ODuBkLUgcxnxIHhA75PCGhPUl7Wxq567opwBQaMKFFfNA+LlIXed6B7vL8+CezBKADSk8ZwmEHd/7v9Rme5Vrqizh52doNP11Nxbziumn2S/RF0g84uUNbaJ6wnrgsWHfohyJFZ8wQzUQ0GBoucWQwpiu/5A325VeuwOhiaAAAAABJRU5ErkJggg==") no-repeat 0 0;background-size: 100% 100%;
                    }
                    .coupon-wrap-r{
                        padding-right:trans(8);
                        i:first-child {
                            font-size: trans(24);color:#666;
                            .price{
                                border-radius: trans(4);font-size: trans(24);padding: 0 0 0 trans(10);
                                span:first-child{
                                    color:#666;margin-right:trans(20);
                                }
                                span:last-child{
                                    color:#FF4F00;font-weight:bold;
                                }
                            }
                        }
                        i:last-child{
                            opacity:0;width:trans(24);height:trans(24);background: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAMAAADW3miqAAAAbFBMVEUAAADX19fHx8fLy8vIyMjIyMjIyMjHx8fJycnIyMjIyMjIyMjIyMjIyMj////Hx8fIyMjIyMjIyMjJycnHx8fIyMjIyMjKysrIyMjLy8vLy8vMzMzT09PKysrIyMjIyMjIyMjJycn////Hx8cRSXgIAAAAI3RSTlMACaQs+e3qujXz4tbAXQLIsp2BdXBoU0xCIh0ZFA7cqpQmBOyetlYAAACsSURBVDjLtdRJFoMgEARQQUCM4pA4RM3M/e8YiwNQLLTX/3XRvIbs1MqlzJkRxnu9EWT9Xh3rpKEcUQ5IP4gqoN4ErSXURNQIZFhgDSUJWkLgTNQAdHnGURMCe9Lqq6DuRN1CoCCBLdTINgaBRUaq21F1QCdR4UxDHH0Spps9v6fNwFwT9q798esul6ixCsix6fnO9TCv+DJNMMqyx8mntzB1k/BhrElfzzn1Bx3DFEGP4MrcAAAAAElFTkSuQmCC") no-repeat 0 0;background-size: 100% 100%;
                        }
                    }
                }
                .btn.red{color:#fff;background-image: linear-gradient(135deg, #FF257F 0%, #FF0047 100%);}
                .btn{
                    font-weight:600 !important;
                    width: trans(718);height: trans(88);border-radius: trans(80);margin: trans(31) auto 0;color: #442509;font-size: trans(32);display: flex;justify-content: center;align-items: center;background:#FDE23D;
                    .pp{
                        span:first-child{color: #442509;padding-right: trans(8);}
                        span:last-child{font-size:trans(30);color: rgba(68,37,9,.4);text-decoration: line-through;}
                    }
                    .fy{color:#fff;}
                }
            }
        }
    }
}

.slideon {
    animation: slideUp .2s 0s linear both;
}
.slideoff {
    animation: slideDown .2s 0s linear both;
}

@keyframes slideUp {
    100% {
        transform: translate3d(0,0,0);
    }
}

@keyframes slideDown {
    0% {
        transform: translate3d(0,0,0);
    }
    100% {
        transform: translate3d(0,100%,0);
    }
}


</style>













// WEBPACK FOOTER //
// src/components/web/pay/comp/pullupvip/main.vue